<template>
  <div v-if="(tools?.length ?? 0) > 0" class="flex flex-col gap-4">
    <!--通用表单-->
    <template v-for="interaction of tools ?? []">
      <SelectTimeRange
        v-if="interaction.name === 'select_time_range'"
        :key="interaction.id"
        :startTime.sync="formModel.startTime"
        :endTime.sync="formModel.endTime"
      />
    </template>
    <!--提交按钮-->
    <el-button
      :loading="submitting"
      :disabled="submitted"
      class="w-full"
      type="primary"
      @click="handleConfirm"
    >
      Confirm
    </el-button>
  </div>
</template>

<script>
import SelectTimeRange from "./SelectTimeRange.vue";
import { sendToolCall } from "@/api";

export default {
  name: "MessageFormWidget",
  components: { SelectTimeRange },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    /**
     * bug:vue2 bug 必需保持直接依赖不然不显示
     */
    tools: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formModel: {},
      submitting: false,
      submitted: false,
    };
  },
  methods: {
    async handleConfirm() {
      const conversationId = this.value?.conversationId;
      const tool = this.value?.tool_interactions?.find(
        (t) => t.name === "select_time_range"
      );

      try {
        this.submitting = true;
        const submitModel = {
          conversationId,
          toolCallId: tool?.id,
          body: { result: this.formModel },
        };
        console.log("Submitting tool call:", submitModel);
        await sendToolCall(submitModel);
        this.submitted = true;
      } finally {
        this.submitting = false;
      }
      this.$emit("confirm", this.formModel);
    },
  },
};
</script>
